import { atsOptimizedTemplate } from '../templates/ats-optimized'

// All OpenAI calls go through the ferl server — key lives on EC2, never in the browser.
const API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3001'
  : ''

async function post(endpoint, body) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || `Server error ${res.status}`)
  return data
}

class AIService {
  constructor() {
    this.initialized = false
  }

  static getInstance() {
    if (!AIService._instance) AIService._instance = new AIService()
    return AIService._instance
  }

  async init() {
    // No client-side key needed — server handles auth
    this.initialized = true
  }

  async generateResumeFromProfile(profile, jobDescription, jobTitle, company) {
    const parsed = await post('/api/ark/generate-resume', {
      profile,
      jobDescription,
      jobTitle,
      company,
    })

    const template = JSON.parse(JSON.stringify(atsOptimizedTemplate))
    template.sections = template.sections.map(section => {
      if (section.type === 'contact') {
        return {
          ...section,
          sectionData: {
            name: profile.name,
            email: profile.email,
            phone: profile.phone,
            location: profile.location,
            links: [
              ...(profile.linkedin ? [{ label: 'LinkedIn', url: profile.linkedin }] : []),
              ...(profile.github   ? [{ label: 'GitHub',   url: profile.github   }] : []),
            ],
          },
        }
      }
      if (section.type === 'summary') {
        return { ...section, content: [{ type: 'paragraph', children: [{ text: parsed.summary }] }] }
      }
      if (section.type === 'experience') {
        return {
          ...section,
          sectionData: profile.experience.map(exp => ({
            company: exp.company,
            position: exp.title,
            startDate: exp.startDate,
            endDate: exp.current ? 'Present' : exp.endDate,
            location: '',
            highlights: (parsed.experienceBullets?.[exp.company] || exp.bullets).map(b => ({
              type: 'paragraph', children: [{ text: b }],
            })),
            achievements: [],
          })),
        }
      }
      if (section.type === 'education') {
        return {
          ...section,
          sectionData: profile.education.map(edu => ({
            institution: edu.school,
            degree: edu.degree,
            field: edu.field,
            startDate: edu.startDate,
            endDate: edu.endDate,
            gpa: edu.gpa,
            highlights: [],
          })),
        }
      }
      if (section.type === 'skills') {
        return { ...section, content: [{ type: 'paragraph', children: [{ text: parsed.skills }] }] }
      }
      return section
    })
    return template
  }

  async parseProfileFromResume(resumeText) {
    return post('/api/ark/parse-profile', { resumeText })
  }
}

export const aiService = AIService.getInstance()
